import React from 'react';
import createReactClass from 'create-react-class';
import PropTypes from 'prop-types';
import ImmutableRenderMixin from 'react-immutable-render-mixin';
import numeral from 'numeral';
import {connect} from 'react-redux';
import {Link} from 'react-router';
import {Range} from 'immutable';
import {default as Spinner, SIZE_LARGE} from 'components/Spinner';
import {default as Tooltip, TOOLTIP_POSITION_RIGHT, TOOLTIP_POSITION_TOP} from 'components/Tooltip';
import WoffEmbeddedText from 'components/WoffEmbeddedText';
import {Request, RequestsMixin, GET, PUT, DELETE} from 'requests';
import {ResourcesMatching, Requesting, Done} from 'requests/components';
import {TYPEFACE_PREVIEW_SPECIMEN} from '../settings';
import TypefacesSettings from './TypefacesSettings';
import RemoveTypefaceModal from './RemoveTypefaceModal';
import TypefaceCardPlaceholder from './TypefaceCardPlaceholder';

const PAD_LIST_WITH_ADDS_TO = 4;

const mapStateToProps = (state, ownProps) => {
  const kitToken = ownProps.params.kitToken;

  return {
    kitToken,
    requests: state.requests,
  };
};

const TypefacesController = createReactClass({
  propTypes: {
    dispatch: PropTypes.func.isRequired,
    kitToken: PropTypes.string.isRequired,
    requests: PropTypes.object.isRequired,
  },

  mixins: [RequestsMixin, ImmutableRenderMixin],

  getInitialState() {
    return {
      showSettings: false,
      showAllowedTooltip: false,
      showCustomTooltip: false,
      showConfirmRemoveModalFor: null,
      preparingToDelete: null,
      focusedOn: null,
    };
  },

  componentWillMount() {
    this.setRequest({
      workingSetTypefaces: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces'],
      }),
    });

    this.setRequest({
      subscription: new Request({
        method: GET,
        url: ['api', 'subscriptions'],
      }),
    });

    this.setRequest({
      typefaceSettings: new Request({
        method: GET,
        url: ['api', 'kits', this.props.kitToken, 'typeface-settings'],
      }),
    });

    this.setRequest({
      characterSets: new Request({
        method: GET,
        url: ['api', 'character-sets'],
      }),
    });
  },

  handleSettingsClicked(event) {
    event.preventDefault();

    this.setState({
      showSettings: true,
    });
  },

  handleSettingsClosed() {
    this.setState({
      showSettings: false,
    });
  },

  handleSettingsSaved(typefaceSettings) {
    this.setRequest({
      updateTypefaceSettings: new Request({
        method: PUT,
        url: ['api', 'kits', this.props.kitToken, 'typeface-settings'],
        record: typefaceSettings,
      }),
    });

    this.setState({
      showSettings: false,
    });
  },

  removeWorkingSetTypeface(workingSetTypeface) {
    this.setState({
      isRemoving: workingSetTypeface,
    });

    this.setRequest({
      removeWorkingSetTypeface: new Request({
        method: DELETE,
        url: ['api', 'kits', this.props.kitToken, 'working-set-typefaces', workingSetTypeface.id],
        record: workingSetTypeface,
      }),
    });
  },

  handleConfirmedRemoveTypeface(workingSetTypeface) {
    this.removeWorkingSetTypeface(workingSetTypeface);

    this.setState({showConfirmRemoveModalFor: null});
  },

  handleCloseConfirmRemoveTypeface() {
    this.setState({showConfirmRemoveModalFor: null});
  },

  resources() {
    const rm = this.resourceManager();

    return {
      workingSetTypefaces: rm.type(this.requests.workingSetTypefaces, 'working-set-typefaces').all(),
      characterSets: rm.type(this.requests.characterSets, 'character-sets').all(),
      typefaceSettings: rm.type(this.requests.typefaceSettings, 'typeface-settings').get(),
      subscription: rm.type(this.requests.subscription, 'subscriptions').get(),
    };
  },

  renderRemoveWorkingSetTypeface(workingSetTypeface) {
    const focusedOn = (this.state.focusedOn === workingSetTypeface);
    const {family: fontFamily, weight: fontWeight, style: fontStyle} = workingSetTypeface;
    const typefaceName = `${fontFamily} ${fontWeight} ${(fontStyle !== 'normal') ? fontStyle : ''}`;
    const preparingToDelete = (this.state.preparingToDelete === workingSetTypeface);
    const handleDeleteClicked = (event) => {
      event.preventDefault();
      event.stopPropagation();

      this.removeWorkingSetTypeface(workingSetTypeface);
    };
    const confirmRemoveTypeface = (event) => {
      event.preventDefault();
      event.stopPropagation();

      this.setState({showConfirmRemoveModalFor: workingSetTypeface});
    };
    const handlePreparingToDelete = () => {
      this.setState({preparingToDelete: workingSetTypeface});
    };
    const handleNotPreparingToDelete = () => {
      this.setState({preparingToDelete: null});
    };
    const makeDeleteTooltip = () => {
      return (
        <Tooltip
          icon="ficon-times-circle"
          position={TOOLTIP_POSITION_RIGHT}
          content={`Remove ${typefaceName}`}
        />
      );
    };

    return (
      <div
        className="asset-remove cursor-pointer"
        onClick={(workingSetTypeface.custom) ? confirmRemoveTypeface : handleDeleteClicked}
        onMouseEnter={handlePreparingToDelete}
        onMouseLeave={handleNotPreparingToDelete}
      >
        <div style={{position: 'relative'}}>
          {(focusedOn && preparingToDelete) ? makeDeleteTooltip() : null}
          <i className="ficon ficon-times"></i>
        </div>
      </div>
    );
  },

  renderWorkingSetTypefaceFinished(workingSetTypeface) {
    const {family: fontFamily, weight: fontWeight, style: fontStyle} = workingSetTypeface;
    const typefaceName = `${fontFamily} ${fontWeight} ${(fontStyle !== 'normal') ? fontStyle : ''}`;
    const makeEditViewTooltip = () => {
      return (
        <Tooltip
          icon="ficon-pencil"
          position={TOOLTIP_POSITION_TOP}
          content={`Edit ${typefaceName}`}
        />
      );
    };
    const focusedOn = (this.state.focusedOn === workingSetTypeface);
    const preparingToDelete = (this.state.preparingToDelete === workingSetTypeface);
    const handleFocusedOnTypeface = () => {
      this.setState({focusedOn: workingSetTypeface});
    };
    const handleFocusedOnNothing = () => {
      this.setState({focusedOn: null});
    };

    return (
      <Link
        key={`working-set-typeface-${workingSetTypeface.id}`}
        to={`/kits/${this.props.kitToken}/typefaces/${workingSetTypeface.id}`}
        className="kit-typeface kit-typeface-emphasis asset asset-typeface link-dashed-none br-a"
        onMouseEnter={handleFocusedOnTypeface}
        onMouseLeave={handleFocusedOnNothing}
      >
        {(focusedOn && !preparingToDelete) ? makeEditViewTooltip() : null}
        <div className="asset-inner">
          <div className="asset-preview">
            <WoffEmbeddedText
              className="kit-typeface-pangram"
              text={TYPEFACE_PREVIEW_SPECIMEN}
              woff={workingSetTypeface.woff}
            />
          </div>
        </div>

        {this.renderRemoveWorkingSetTypeface(workingSetTypeface)}
      </Link>
    );
  },

  renderWorkingSetTypefaceErrored(workingSetTypeface) {
    return (
      <div key={`working-set-typeface-${workingSetTypeface.id}`} className="kit-typeface asset asset-error asset-typeface asset-typeface-error br-a p-xs-a-md">
        <div className="asset-inner text-xs-center">
          <span className="inline-block text-danger word-wrap">
            Upload of {workingSetTypeface.name} failed
          </span>
        </div>

        {this.renderRemoveWorkingSetTypeface(workingSetTypeface)}
      </div>
    );
  },

  renderWorkingSetTypefaceProcessing(workingSetTypeface) {
    return (
      <div key={`working-set-typeface-${workingSetTypeface.id}`} className="kit-typeface asset asset-processing asset-typeface asset-typeface-processing br-a p-xs-a-md">
        <div className="asset-inner text-xs-center animated infinite pulseOpacity">
          <i className="ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-r-sm"></i>
          adding {workingSetTypeface.name} &hellip;
        </div>
      </div>
    );
  },

  renderWorkingSetTypefaceRemoving(workingSetTypeface) {
    return (
      <div key={`working-set-typeface-${workingSetTypeface.id}`} className="kit-typeface asset asset-processing asset-typeface asset-typeface-processing br-a p-xs-a-md">
        <div className="asset-inner text-xs-center animated infinite pulseOpacity">
          <i className="ficon ficon-spinner-third ficon-spin ficon-lg block m-xs-r-sm"></i>
          removing {workingSetTypeface.name} &hellip;
        </div>
      </div>
    );
  },

  renderFailureAlert() {
    const {
      workingSetTypefaces,
    } = this.resources();
    const failedWorkingSetTypefaces = workingSetTypefaces.filter((workingSetTypeface) => {
      return workingSetTypeface.status === 'errored';
    });

    let value = null;

    if (!failedWorkingSetTypefaces.isEmpty()) {
      value = (
        <div className="alert alert-danger bg-body m-xs-b-lg">
          <strong>Upload your typefaces we could not.</strong> Please try again or <a href="mailto:help@fortawesome.com" className="text-danger">let us know</a> if you continue to have trouble.
        </div>
      );
    }

    return value;
  },

  renderWorkingSetTypeface(workingSetTypeface) {
    const {isRemoving} = this.state;
    let value = null;

    switch (workingSetTypeface.status) {
      case 'finished':
        value = this.renderWorkingSetTypefaceFinished(workingSetTypeface);
        break;
      case 'errored':
        value = this.renderWorkingSetTypefaceErrored(workingSetTypeface);
        break;
      default:
        value = this.renderWorkingSetTypefaceProcessing(workingSetTypeface);
    }

    if (workingSetTypeface === isRemoving) {
      value = this.renderWorkingSetTypefaceRemoving(workingSetTypeface);
    }

    return value;
  },

  renderGroups() {
    const {
      workingSetTypefaces,
    } = this.resources();
    const needsThisManyAdds = (workingSetTypefaces.size >= PAD_LIST_WITH_ADDS_TO) ? 1 : PAD_LIST_WITH_ADDS_TO - workingSetTypefaces.size;
    const groupedWorkingSetTypefaceElements = workingSetTypefaces
      .groupBy((workingSetTypeface) => workingSetTypeface.family)
      .sortBy((_, family) => family)
      .map((groupedWorkingSetTypefaces, family) => {
        const stylesCount = groupedWorkingSetTypefaces.size;
        const makeFamilySummary = () => {
          const label = (stylesCount === 1) ? 'Style' : 'Styles';
          const sizes = groupedWorkingSetTypefaces.map((workingSetTypeface) => {
            const style = (workingSetTypeface.style === 'normal') ? '' : workingSetTypeface.style;
            const size = (workingSetTypeface.optimizedSize) ? numeral(workingSetTypeface.optimizedSize).format('0b') : '?';

            return `${workingSetTypeface.weight} ${style} (${size})`;
          }).join(' · ');

          return (
            <div className="pull-right">
              <span>{stylesCount} {label}</span> · <span>{sizes}</span>
            </div>
          );
        };
        const workingSetTypefaceElements = groupedWorkingSetTypefaces.map(this.renderWorkingSetTypeface);

        return (
          <div className="kit-typeface-group m-xs-b-lg" key={`typeface-${family}`}>
            {workingSetTypefaceElements}

            <div className="text-muted asset-label" data-role="group-details">
              <hr className="m-xs-y-sm" />

              <span className="kit-typeface-group-name" data-role="group-name">{family}</span>

              {makeFamilySummary()}
            </div>
          </div>
        );
      });
    const addElements = Range(0, needsThisManyAdds).map((index) => {
      return <TypefaceCardPlaceholder key={`add-typeface-${index}`} kitToken={this.props.kitToken} />;
    });

    return (
      <div className="kit-assets kit-assets-named kit-assets-typefaces">
        {[...groupedWorkingSetTypefaceElements.values()]}
        {addElements}
      </div>
    );
  },

  renderUsage() {
    function toggleTooltip(what) {
      const nextState = {};
      nextState[what] = !this.state[what];
      this.setState(nextState);
    }

    const {
      workingSetTypefaces,
      subscription,
    } = this.resources();
    const {showAllowedTooltip, showCustomTooltip} = this.state;

    const typefacesAllowed = subscription.workingSetTypefacesAllowed;
    const typefacesUsed = workingSetTypefaces.size;
    const typefacesOutOf = (typefacesAllowed === Infinity) ? <span>&infin;</span> : typefacesAllowed;

    const customTypefacesAllowed = subscription.customTypefacesAllowed;
    const customUsed = workingSetTypefaces.filter((i) => i.custom).size;
    const customOutOf = (customTypefacesAllowed === Infinity) ? <span>&infin;</span> : customTypefacesAllowed;

    const makeTooltip = (used, outOf, what) => {
      return (
        <Tooltip
          noIcon={true}
          content={<span>Using {used} of {outOf} {what}<br /> per kit available in your plan</span>}
        />
      );
    };

    const allowedTooltip = (showAllowedTooltip) ? makeTooltip(typefacesUsed, typefacesOutOf, 'typefaces') : null;
    const customTooltip = (showCustomTooltip) ? makeTooltip(customUsed, customOutOf, 'uploaded typefaces') : null;
    const toggleAllowed = toggleTooltip.bind(this, 'showAllowedTooltip');
    const toggleCustom = toggleTooltip.bind(this, 'showCustomTooltip');

    return (
      <div className="text-muted m-xs-b-md">
        <span
          onMouseEnter={toggleAllowed}
          onMouseLeave={toggleAllowed}
          style={{position: 'relative'}}
          className="text-muted"
        >
          {allowedTooltip}
          Using {typefacesUsed} of {typefacesOutOf} available
        </span>
        <span> &middot; </span>
        <span
          onMouseEnter={toggleCustom}
          onMouseLeave={toggleCustom}
          style={{position: 'relative'}}
          className="use-count-uploaded"
        >
          {customTooltip}
          <i className="ficon ficon-uploaded"></i> {customUsed}
        </span>
        <span> &middot; </span>
        <a href="/upgrade">Get More</a>
      </div>
    );
  },

  renderCluestick() {
    const {
      kitToken,
    } = this.props;
    const {
      workingSetTypefaces,
    } = this.resources();

    let cluestickElement = null;

    if (workingSetTypefaces.size === 0) {
      cluestickElement = (
        <div className="layout-center-center well bg-info bg-img bg-img-icons p-xs-a-xl m-xs-y-md text-xs-center" role="alert">
          <div className="text-muted m-xs-b-md">
            <i className="ficon ficon-typeface ficon-5x"></i>
          </div>
          <h2 className="text-2x m-xs-b-md font-weight-semibold">Shrink and serve your site’s typefaces!</h2>

          <p className="lead text-muted m-xs-b-0">
            <Link to={`/kits/${kitToken}/typefaces/new`} className="text-white">Choose</Link> from our hand-picked typefaces and <Link to={`/kits/${kitToken}/typefaces/upload`} className="text-white">upload your own</Link>.<br/>
            We’ll help you subset down to just the languages your site uses, then serve them up right on your site.
          </p>
        </div>
      );
    }

    return cluestickElement;
  },

  renderRemoveTypefaceModal() {
    return (
      <RemoveTypefaceModal
        show={!!this.state.showConfirmRemoveModalFor}
        workingSetTypeface={this.state.showConfirmRemoveModalFor}
        onRemovedTypeface={this.handleConfirmedRemoveTypeface}
        onClosed={this.handleCloseConfirmRemoveTypeface}
      />
    );
  },

  renderSpinner() {
    <div className="is-loading is-loading-typefaces m-xs-x-0 bg-body p-xs-a-xl br-a">
      <Spinner size={SIZE_LARGE} />
    </div>
  },

  render() {
    const {
      kitToken,
    } = this.props;
    const {
      workingSetTypefaces: workingSetTypefacesRequest,
      subscription: subscriptionRequest,
      typefaceSettings: typefaceSettingsRequest,
      characterSets: characterSetsRequest,
    } = this.requests;
    const {
      workingSetTypefaces,
      typefaceSettings,
      characterSets,
    } = this.resources();

    const addLabel = (workingSetTypefaces.size > 0) ? 'Add Typefaces' : 'Add your first TYPEFACE';

    return (
      <ResourcesMatching manager={this.resourceManager()}>
        <div className="kit-asset-summary">
          <div className="kit-asset-header gg gg-bottom">
            <h3 className="kit-asset-title gg-col">
              Typefaces
              &thinsp;
              <a onClick={this.handleSettingsClicked} href="#" className="text-muted text-lg has-tooltip link-dashed-none valign-middle m-xs-l-xs">
                <Done all={[typefaceSettingsRequest, characterSetsRequest]}>
                  <i className="ficon ficon-gear" />
                </Done>
              </a>
            </h3>
            <div className="kit-asset-actions gg-col text-xs-right text-muted">
              <Link to={`/kits/${kitToken}/typefaces/new`} className="link-dashed-none m-xs-r-md">
                <i className="ficon ficon-plus-circle m-xs-r-xs" />{addLabel}
              </Link>
              <Link to={`/kits/${kitToken}/typefaces/upload`} className="link-dashed-none">
                <i className="ficon ficon-uploaded m-xs-r-xs" />Upload
              </Link>
            </div>
          </div>
          <hr className="m-xs-y-sm" />
          <Done all={[workingSetTypefacesRequest, subscriptionRequest]} render={this.renderUsage} />
          <Done request={workingSetTypefacesRequest} render={this.renderCluestick} />
          <Done request={workingSetTypefacesRequest} render={this.renderFailureAlert} />
          <Done request={workingSetTypefacesRequest} render={this.renderGroups} />
          <Requesting request={workingSetTypefacesRequest} render={this.renderSpinner} />
        </div>

        <Done request={workingSetTypefacesRequest} render={this.renderRemoveTypefaceModal} />

        <Done all={[typefaceSettingsRequest, characterSetsRequest]}>
          <TypefacesSettings
            show={this.state.showSettings}
            typefaceSettings={typefaceSettings}
            characterSets={characterSets}
            onClosed={this.handleSettingsClosed}
            onSaved={this.handleSettingsSaved}
          />
        </Done>
      </ResourcesMatching>
    );
  },
});

export default connect(mapStateToProps)(TypefacesController);



// WEBPACK FOOTER //
// ./app/javascript/views/Kits/components/TypefacesController.js